// @flow
import * as React from "react"
import { Link } from "react-static"
import { hot } from "react-hot-loader"
import { ImageFit } from "../../components/ImageFit"
import { setHtml } from "../../utils"
import { LazyLoadImage } from "../../components/LazyLoadImage"
import {
  tRouteProps,
  tClassOfferingsTemplate as tCoreClassesTemplate,
  tDefaultTemplate
} from "../../types"
import { Container } from "../../components/StyledComponents"
import { css } from "emotion/macro"
import { mq } from "../../styles/variables"
import { FlexibleContent } from "../../components/FlexibleContent"
import { PageMarquee } from "../../components/PageMarquee"
import { PageMeta } from "../../components/PageMeta"
import { ActivitesAndEventsSlider } from "../../components/FlexibleContent/ActivitesAndEventsSlider"

type tCoreClasses = {}

function CoreClasses(
  props: tCoreClasses &
    tRouteProps &
    tCoreClassesTemplate &
    tDefaultTemplate
) {
  const {
    learn_template_content: { core_courses }
  } = props

  return (
    <React.Fragment>
      {props.default_template_content && (
        <PageMarquee image={props.default_template_content.marquee_image} />
      )}
      <Container
        className={css`
          position: relative;
        `}
      >
        <PageMeta
          title={props.title}
          description="Core Practical Spirituality, spirit@work, and advanced spirituality"
          image={props.default_template_content.marquee_image}
        />
        <section
          id="core-practical-spirituality"
          className={css`
            padding-top: 30px;
            text-align: center;

            > p {
              margin-bottom: 30px;
            }

            img {
              max-width: 100%;
            }

            .core-courses {
              display: flex;
              flex-wrap: wrap;
            }

            article {
              width: 100%;
              margin-bottom: 30px;
            }

            h2 {
              margin-top: 45px;
            }

            ${mq.md(css`
              article {
                width: calc(50% - 15px);

                &:nth-of-type(odd) {
                  margin-right: 30px;
                }
              }
            `)};
          `}
        >
          <div
            {...setHtml(props.learn_template_content.core_courses_header)}
            className={css`
              max-width: 890px;
              margin: 0 auto 30px;
            `}
          />
          <div className="core-courses">
            {core_courses.map((course) => {
              const content = (
                <React.Fragment>
                  {course.image && course.image.url && (
                    <ImageFit
                      className={css`
                        width: 100%;
                        max-width: 100%;
                        height: 200px;
                      `}
                      src={course.image.url}
                      alt={course.image.alt}
                    />
                  )}
                  <h3
                    className={`h4 ${css`
                      font-weight: 400;
                      text-transform: none;
                      line-height: 1.2;
                      margin-bottom: 15px;
                      margin-top: 5px;
                    `}`}
                    {...setHtml(course.title)}
                  />
                </React.Fragment>
              )
              return (
                <article className="course" key={course.title}>
                  {course.url ? (
                    <Link to={course.url}>{content}</Link>
                  ) : (
                    <div>{content}</div>
                  )}

                  <div {...setHtml(course.content)} />
                </article>
              )
            })}
          </div>
        </section>
        {props.flexible_content && (
          <FlexibleContent items={props.flexible_content} />
        )}
      </Container>
    </React.Fragment>
  )
}

export default hot(module)(CoreClasses)



// WEBPACK FOOTER //
// /opt/build/repo/src/screens/Page/CoreClasses.js